import { render, staticRenderFns } from "./ShowOneStage.vue?vue&type=template&id=4dfb6082&scoped=true"
import script from "./ShowOneStage.vue?vue&type=script&lang=js"
export * from "./ShowOneStage.vue?vue&type=script&lang=js"
import style0 from "./ShowOneStage.vue?vue&type=style&index=0&id=4dfb6082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb6082",
  null
  
)

export default component.exports